export const getIsSensitivePropertyGroupNameModified = ({
  originalSpgName,
  isNewSpg,
}: {
  originalSpgName: string | undefined;
  isNewSpg: boolean;
}) => Boolean(isNewSpg || originalSpgName);

export const getAddedSensitivePropertyGroupAttributes = ({
  currentSpg,
  previousSpg,
  isNewSpg,
}: {
  currentSpg: string[] | undefined;
  previousSpg: string[] | undefined;
  isNewSpg: boolean;
}) => {
  const addedAttributes = new Set(currentSpg || []);

  if (!isNewSpg) {
    previousSpg?.forEach((attributeIri) => {
      addedAttributes.delete(attributeIri);
    });
  }

  return addedAttributes;
};
